module.exports = __webpack_public_path__ + "static/media/evx.f13e8763.svg";